module.exports = __webpack_public_path__ + "04_bob_grey.b24546e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/04_bob_grey.png
// module id = JFTe
// module chunks = 0